module.exports = __webpack_public_path__ + "img/arrow-read-more.0ea3bc3c.svg";